__turbopack_context__.v({
  "arrow": "ScriptCallItems-module__614Laa__arrow",
  "arrowOpen": "ScriptCallItems-module__614Laa__arrowOpen",
  "container": "ScriptCallItems-module__614Laa__container",
  "count": "ScriptCallItems-module__614Laa__count",
  "head": "ScriptCallItems-module__614Laa__head",
  "headStatic": "ScriptCallItems-module__614Laa__headStatic",
  "item": "ScriptCallItems-module__614Laa__item",
  "label": "ScriptCallItems-module__614Laa__label",
  "list": "ScriptCallItems-module__614Laa__list",
  "placeholder": "ScriptCallItems-module__614Laa__placeholder",
  "response": "ScriptCallItems-module__614Laa__response",
  "responseText": "ScriptCallItems-module__614Laa__responseText",
  "title": "ScriptCallItems-module__614Laa__title",
});
